import React, { useEffect, useState } from "react";
import Hero from "../../components/pages/Track/Hero/Hero";
import CaseResult from "../../components/pages/Track/CaseResult/CaseResult";
import StatusGuide from "../../components/pages/Track/StatusGuide/StatusGuide";
import "./Track.css";
import Help from "../../components/pages/About/Help/Help";

const Track = () => {
  const [foundCaseId, setFoundCaseId] = useState(null);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [foundCaseId]);

  return (
    <div className="track-page">
      <div className="track-page__grid-section">
        {foundCaseId ? (
          <CaseResult
            caseId={foundCaseId}
            onBack={() => setFoundCaseId(null)}
          />
        ) : (
          <Hero onFound={setFoundCaseId} />
        )}
      </div>
      <StatusGuide />
      <Help/>
    </div>
  );
};

export default Track;
